import { Platform } from "@prisma/client";
import { DiscordCategoryCreate, TriggerCreate } from "../../../libs/types/src";

/**
 * 2908TODO documentation
 * @param guildId
 * @param guildName
 * @param workspaceId
 * @param messageId
 * @param buttonId
 * @returns
 */

const workspaceId = "";
const guildId = "685243210829922350";

const guildAlias = "test";
const stepCommon: {
  platform: Platform;
  communityId: string;
  workspace: string;
} = {
  platform: "discord",
  communityId: guildId,
  workspace: workspaceId,
};
const alias = `${guildAlias}-ephemeral-demo`;

export const trigger: TriggerCreate = {
  platform: "discord",
  communityId: guildId,
  workspace: workspaceId,
  name: "Demo Private Channel Onboarding",
  authorUserId: "598367975573291021",
  type: "team_join",
  configs: {
    messages: [
      {
        id: "messageId",
        buttonIds: ["buttonId"],
      },
    ],
  },
  steps: [
    {
      ...stepCommon,
      id: `${alias}-step0`,
      type: "create_channel",
      isEntry: true,
      configs: {
        channelName: "onboard-{{user.username}}",
        userIds: ["{{user.id}}"],
        isPrivate: true,
        channelType: "onboarding",
      },
      transitions: [{ targetStepId: `${alias}-initial-message` }],
    },
    {
      ...stepCommon,
      id: `${alias}-initial-message`,
      type: "send_message",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: `Welcome <@{{user.id}}> to the community! We are glad to have you here.`,
      },
      transitions: [
        {
          targetStepId: `${alias}-step-test-captcha`,
        },
      ],
    },

    {
      id: `${alias}-step-test-captcha`,
      type: "test_captcha",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        userId: "{{user.id}}",
        guildId: guildId,
        message:
          "Hey, you're not a robot right? Please solve this captcha to proceed:",
      },
      transitions: [
        {
          targetStepId: `${alias}-brings-you-here`,
          when: {
            userResponse: {
              type: "captcha-result",
              channelId: `{{${alias}-step0.channelId}}`,
              userId: "{{user.id}}",
              succeeded: true,
            },
          },
        },
        {
          targetStepId: `${alias}-step-test-captcha`,
          when: {
            userResponse: {
              type: "captcha-result",
              channelId: `{{${alias}-step0.channelId}}`,
              userId: "{{user.id}}",
              succeeded: false,
            },
          },
        },
      ],
    },

    {
      ...stepCommon,
      id: `${alias}-brings-you-here`,
      type: "send_survey",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: `\n\n**What brings you here**?`,
        type: "buttons",
        options: [
          { emoji: "🎓", id: "learn", label: "Learn about your product" },
          {
            emoji: "👥",
            id: "others",
            label: "See what others are building",
          },
          { emoji: "💻", id: "trouble", label: "Troubleshoot" },
        ],
      },
      transitions: [
        {
          targetStepId: `${alias}-step3-student`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-brings-you-here.messageId}}`,
              buttonId: "learn",
            },
          },
        },
        {
          targetStepId: `${alias}-step3-see-others`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-brings-you-here.messageId}}`,
              buttonId: "others",
            },
          },
        },
        {
          targetStepId: `${alias}-step3-troubleshoot`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-brings-you-here.messageId}}`,
              buttonId: "trouble",
            },
          },
        },
      ],
    },
    {
      ...stepCommon,
      id: `${alias}-step3-student`,
      type: "send_message",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: `Dots helps Discord communities improve their member experience by easily creating custom onboarding and support flows. \n\nYou should see sample flows on the left to play around. Feel free to ask any questions in #general.`,
      },
      transitions: [{ targetStepId: `${alias}-step4` }],
    },
    {
      ...stepCommon,
      id: `${alias}-step3-see-others`,
      type: "send_message",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: `Amazing! Please join the discussion on discord automation and bots in #general. You can also meet others by introducing yourself in #general.
            `,
      },
      transitions: [{ targetStepId: `${alias}-step4` }],
    },
    {
      ...stepCommon,
      id: `${alias}-step3-troubleshoot`,
      type: "send_message",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message:
          "Thanks for being an early supporter! You can post your question in #general.",
      },
      transitions: [{ targetStepId: `${alias}-step4` }],
    },

    {
      ...stepCommon,
      id: `${alias}-step4`,
      type: "send_survey",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: `\nWould you want to share your email address so we can keep you updated? We won't spam you!`,
        type: "buttons",
        options: [
          { emoji: "✅", id: "yes", label: "Sure!" },
          { emoji: "❌", id: "no", label: "No thanks" },
        ],
      },
      transitions: [
        {
          targetStepId: `${alias}-step-email`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step4.messageId}}`,
              buttonId: "yes",
            },
          },
        },
        {
          targetStepId: `${alias}-final-message`,
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: `{{${alias}-step4.messageId}}`,
              buttonId: "no",
            },
          },
        },
      ],
    },
    {
      ...stepCommon,
      id: `${alias}-step-email`,
      type: "send_message",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: `Please enter your email address. If you prefer not, type skip.`,
      },
      transitions: [
        {
          targetStepId: `${alias}-waitfor-email`,
        },
      ],
    },
    {
      id: `${alias}-waitfor-email`,
      type: "idle",
      transitions: [
        {
          targetStepId: `${alias}-final-message`,
          when: {
            userResponse: {
              type: "message",
              channelId: `{{${alias}-step0.channelId}}`,
              userId: "{{user.id}}",
              content: {
                has: "email",
              },
            },
          },
        },
        {
          targetStepId: `${alias}-step-skip-email`,
          when: {
            userResponse: {
              type: "message",
              channelId: `{{${alias}-step0.channelId}}`,
              userId: "{{user.id}}",
              content: "skip",
            },
          },
        },
        {
          targetStepId: `${alias}-step-not-email`,
          when: {
            userResponse: {
              type: "message",
              channelId: `{{${alias}-step0.channelId}}`,
              userId: "{{user.id}}",
              and: [
                { content: { hasnot: "email" } },
                { content: { neq: "skip" } },
              ],
            },
          },
        },
      ],
    },
    {
      ...stepCommon,
      id: `${alias}-step-skip-email`,
      type: "send_message",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: "Okay, no worries.",
      },
      transitions: [{ targetStepId: `${alias}-final-message` }],
    },
    {
      ...stepCommon,
      id: `${alias}-step-not-email`,
      type: "send_message",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: "Hmm, this does not look like an email. Please enter again",
      },
      transitions: [{ targetStepId: `${alias}-waitfor-email` }],
    },

    {
      ...stepCommon,
      id: `${alias}-final-message`,
      type: "send_message",
      configs: {
        channelId: `{{${alias}-step0.channelId}}`,
        message: `\n\n Great! You have access to the server. Thanks for being part of our community! \nPS: This channel will be automatically deleted in 1 hour. Please reach out to us if you have any questions! `,
      },
      transitions: [{ targetStepId: `${alias}-step-delete` }],
    },
    {
      ...stepCommon,
      id: `${alias}-step-delete`,
      isGoal: true,
      type: "delete_channel",
      configs: {
        delaySeconds: 60 * 60,
        channelId: `{{${alias}-step0.channelId}}`,
      },
      transitions: [],
    },
  ],
};
